module.exports = __webpack_public_path__ + "media/unipod/pos_assembly_4-0d7b157a.jpg";